<script>
export default {
    name: "ViewCardexNotes",

    props: {
        showModal: Boolean,
        nursingCardex: Object,
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-3/4 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Cardex Notes</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap -m-2">
            <div class="md:w-1/4 w-full">
                <h5 class="font-medium text-base">Date: {{ nursingCardex.date | dateFormat }}</h5></div>
            <div class="md:w-1/4 w-full">
                <h5 class="font-medium text-base">Time: {{ nursingCardex.time }}</h5></div>
            <div class="w-full mt-2" style="max-height:50vh;">
                <span v-html="nursingCardex.cardexNotes"></span>
            </div>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>